<template>
	<div class="">
		<video id="swiper_img" class='swiper_img'
		  v-if="default_video_url.videoUrl" controls="controls" autoplay="autoplay"  webkit-playsinline="true" :poster="default_video_url.imgesUrl"   :src="default_video_url.videoUrl"></video>
	</div>
</template>

<script>
	import wx from "weixin-js-sdk"
	export default {
	    name: 'shopDetails',
	    data(){
			return {
				default_video_url:{}
			}
		},
		created(){
			this.default_video_url=this.$route.query
		},
		mounted(){
			function autoPlayVideo(){
				wx.config({
					debug:false,
					appId:"",
					timestamp:1,
					nonceStr:"",
					signature:"",
					jsApiList:[]
				});
				wx.ready(function(){
					var autoplayVideo=document.getElementById("swiper_img");
					autoplayVideo.play()
				})
			};
			autoPlayVideo();
			
		}
	}
</script>

<style>
	.swiper_img{width: 100%;height: 100vh;}
</style>
